var tl = new TimelineMax({paused:true}).staggerFromTo('.videocontainer, h1, p, .ziua-reintalnirii-stripe', 0.5, {opacity:0,y: 20}, {opacity:1, y:0, ease: Power2.easeOut}, 0.25),
	player;

function onYouTubeIframeAPIReady() {
	player = new YT.Player('player', {
		height: '315',
		width: '560',
		videoId: 'WHCrsQjxRnE',
		//host: 'http://bergenbier.lara',
		playerVars: {
			modestbranding: 1,
			rel: 0
		},
		events: {
			//'onReady': onPlayerReady,
			'onStateChange': onPlayerStateChange
		}
	});
}

function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.PLAYING) {
		if (window.ga) {
			ga('send', 'event', 'ZiuaReîntâlnirii', 'Play Video');
		}
	}
}

$(window).load(function() {
	TweenMax.to($('.preloader'), .5, {
		delay: 0.5,
		opacity: 0,
		display: 'none',
        onComplete: function(){
			tl.play();
        }
	});

	$('.ziua-reintalnirii-stores a').on('click', function(){
		var store = $(this).data('store');
		if (window.ga && store) {
			ga('send', 'event', 'ZiuaReîntâlnirii', store);
		}
	});
});
